<template>
  <section>
    <b-row>
      <b-col>
        <b-card v-if="loading">
          <b-skeleton width="100%" height="300px"></b-skeleton>
        </b-card>
        <b-card v-else>
          <div
            class="d-flex w-100 flex-wrap justify-content-between align-items-center"
          >
            <div class="d-flex flex-wrap">
              <h4 class="m-1">{{ exercise.title }}</h4>
            </div>
            <div class="d-flex">
              <div class="mr-1">
                <span> وضعیت : </span>
              </div>
              <div>
                <b-badge
                  :variant="exercise.active ? 'success' : 'danger'"
                  class="rounded"
                >
                  {{ exercise.active ? "فعال" : "غیر فعال" }}
                </b-badge>
              </div>
            </div>
          </div>
          <div class="mx-1">
            <span v-html="exercise.description"></span>
            <span>{{ " جریمه : " + exercise.penalty + " تومان " }}</span>
          </div>
          <div class="d-flex w-100 flex-wrap">
            <div class="m-1">
              <span>{{ " دوره " + $route.query.course_id }}</span>
            </div>
            <div class="m-1">
              <span>{{ " جلسه " + $route.query.session_id }}</span>
            </div>
            <!-- <div class="m-1">
              تاریخ شروع تمرین‌:
              <b-badge variant="light-success">
                {{ calcDate(exercise.started_at) }}
              </b-badge>
            </div>
            <div class="m-1">
              تاریخ پایان تمرین :
              <b-badge variant="light-warning">
                {{ calcDate(exercise.deadline_at) }}
              </b-badge>
            </div> -->
          </div>
          <data-table
            :fields="fields"
            :items="exercise.questions.questions"
            :loading="loading"
            @onRowClicked="rowClicked"
          >
            <template #id="{ data }">{{ data.item.id }}</template>
            <template #question="{ data }">{{ data.item.question }}</template>

            <template #type="{ data }"
              ><b-badge
                :variant="
                  data.item.type == 1
                    ? 'secondary'
                    : data.item.type == 2
                    ? 'info'
                    : data.item.type == 3
                    ? 'warning'
                    : 'primary'
                "
                >{{
                  data.item.type == 0
                    ? " چند گزینه ای"
                    : data.item.type == 1
                    ? "۴ گزینه ای"
                    : data.item.type == 2
                    ? "تشریحی"
                    : "بله یا خیر"
                }}</b-badge
              ></template
            >
            <template #items="{ data }">
              <template v-if="data.item.items.length">
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  class="btn-icon"
                  :id="'hover-' + data.item.id"
                >
                  <feather-icon size="20" icon="InfoIcon" />
                </b-button>
                <b-popover :target="'hover-' + data.item.id" triggers="hover">
                  <div
                    class="p-1"
                    v-for="(item, index) in data.item.items"
                    :key="index"
                  >
                    {{ item.value }}
                  </div>
                </b-popover>
              </template>

              <div v-else class="d-flex">
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  class="btn-icon px-1"
                >
                  -
                </b-button>
              </div>
            </template>
          </data-table>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <div class="d-flex w-100 justify-content-between px-2 my-2">
            <h4>کاربران پاسخ داده</h4>
            <p>
              تعداد کل :
              {{ paginationAnswer.total }}
            </p>
          </div>
          <data-table
            :fields="usersCoFields"
            :items="users.answered"
            :loading="loading"
          >
            <template #id="{ data }">{{ data.item.id }}</template>
            <template #fullName="{ data }">
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="data.item.first_name"
                :variant="`light-primary`"
              />
              <span class="mx-2">
                {{ data.item.first_name }}
                {{ data.item.last_name }}
              </span>
            </template>
            <template #correctAnswers="{}">
              <b-badge variant="success">4</b-badge>
            </template>
            <template #falseAnswers="{}">
              <b-badge variant="danger">3</b-badge>
            </template>
          </data-table>
          <div
            class="w-100 d-flex flex-wrap justify-content-between align-items-center"
          >
            <div
              class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
            >
              <b-pagination
                v-model="currentPageAnswer"
                :total-rows="paginationAnswer.total"
                :per-page="paginationAnswer.per_page"
                size="md"
                class="my-2 d-flex justify-content-center"
              ></b-pagination>
            </div>
            <b-form
              @submit.prevent="goTo"
              class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
            >
              <div>
                <b-button
                  class="px-50"
                  type="submit"
                  size="sm"
                  variant="primary"
                  >رفتن به
                </b-button>
              </div>
              <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
                <b-form-input
                  id="to-page"
                  type="number"
                  size="sm"
                  :max="paginationAnswer.total_pages"
                  min="1"
                  v-model="choosenPageAnswer"
                />
              </b-form-group>
            </b-form>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <div class="d-flex w-100 justify-content-between px-2 my-2">
            <h4>کاربران پاسخ نداده</h4>
            <p>تعداد کل : {{ paginationNotAnswer.total }}</p>
          </div>
          <data-table
            :fields="usersNotCoFields"
            :items="users.notAnswer"
            :loading="loading"
          >
            <template #id="{ data }">{{ data.item.id }}</template>
            <template #fullName="{ data }">
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="data.item.first_name"
                :variant="`light-primary`"
              />
              <span class="mx-2">
                {{ data.item.first_name }}
                {{ data.item.last_name }}
              </span>
            </template>
          </data-table>
          <div
            class="w-100 d-flex flex-wrap justify-content-between align-items-center"
          >
            <div
              class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
            >
              <b-pagination
                v-model="currentPageNotAnswer"
                :total-rows="paginationNotAnswer.total"
                :per-page="paginationNotAnswer.per_page"
                size="md"
                class="my-2 d-flex justify-content-center"
              ></b-pagination>
            </div>
            <b-form
              @submit.prevent="goTo"
              class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
            >
              <div>
                <b-button
                  class="px-50"
                  type="submit"
                  size="sm"
                  variant="primary"
                  >رفتن به
                </b-button>
              </div>
              <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
                <b-form-input
                  id="to-page"
                  type="number"
                  size="sm"
                  :max="paginationNotAnswer.total_pages"
                  min="1"
                  v-model="choosenPageNotAnswer"
                />
              </b-form-group>
            </b-form>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <show-question v-model="visible" :visible="visible" :question="question" />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BProgress,
  BButton,
  BFormFile,
  BModal,
  VBModal,
  BPopover,
  BBadge,
  BPagination,
  BAvatar,
  BSkeleton,
  BFormInput,
  BForm,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import Ripple from "vue-ripple-directive";
import Timer from "@/@core/components/timer/Timer.vue";
import ShowQuestion from "./ShowQuestion.vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    DataTable,
    BProgress,
    BButton,
    BFormFile,
    BModal,
    BPopover,
    BBadge,
    BPagination,
    Timer,
    BAvatar,
    ShowQuestion,
    BSkeleton,

    BFormInput,
    BForm,
    BFormGroup,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  watch: {
    currentPageAnswer(val) {
      this.choosenPageAnswer = val;
      this.getAnswerUsers(val);
    },
    currentPageNotAnswer(val) {
      this.choosenPagNotAnswer = val;
      this.getNotAnswerUsers(val);
    },
  },
  data() {
    return {
      choosenPageAnswer: 1,
      choosenPageNotAnswer: 1,
      currentPageAnswer: 1,
      currentPageNotAnswer: 1,
      paginationAnswer: {},
      paginationNotAnswer: {},
      totalRows: 100,
      perPage: 4,
      loading: false,
      visible: false,
      users: {
        answered: [],
        notAnswer: [],
      },
      exercise: {},
      question: {},
      usersCoFields: [
        { key: "id", label: "شناسه" },
        { key: "fullName", label: "" },
      ],
      usersNotCoFields: [
        { key: "id", label: "شناسه" },
        { key: "fullName", label: "" },
      ],
      fields: [
        { key: "id", label: "شناسه" },
        { key: "question", label: "سوال" },
        { key: "type", label: "نوع سوال" },
        { key: "items", label: "گزینه ها" },
      ],
    };
  },
  async created() {
    this.loading = true;
    await this.getAnswerUsers();
    await this.getNotAnswerUsers();
    await this.getExercise();
    this.loading = false;
  },
  methods: {
    goTo() {
      this.currentPageAnswer = this.choosenPageAnswer;
    },
    async rowClicked(item) {
      this.question = item;
      this.visible = true;
    },
    async getAnswerUsers(page) {
      try {
        const { data } = await this.$http.post(
          `/panel/exercises/${this.$route.params.id}/users`,
          {
            course_id: this.$route.query.course_id,
            session_id: this.$route.query.session_id,
            type: "0",
            per_page: 10,
            page: page || 1,
          }
        );
        this.users.answered = data.data.users;

        this.paginationAnswer = data.data.meta.pagination;
        this.currentPageAnswer = await this.pagination.current_page;
      } catch (err) {}
    },
    async getNotAnswerUsers(page) {
      try {
        const { data } = await this.$http.post(
          `/panel/exercises/${this.$route.params.id}/users`,
          {
            course_id: this.$route.query.course_id,
            session_id: this.$route.query.session_id,
            type: "1",
            per_page: 10,
            page: page || 1,
          }
        );
        this.users.notAnswer = data.data.users;

        this.paginationNotAnswer = data.data.meta.pagination;
        this.currentPageNotAnswer = await this.pagination.current_page;
      } catch (err) {}
    },
    async getExercise() {
      try {
        const { data } = await this.$http.get(
          `/panel/exercises/${this.$route.params.id}`
        );
        this.exercise = data.data;
      } catch (err) {}
    },
  },
};
</script>

<style>
[dir="rtl"] .bs-popover-right > .arrow,
[dir="rtl"] .bs-popover-auto[x-placement^="right"] > .arrow {
  left: -1rem;
  right: 102%;
  transform: rotate(180deg);
}
</style>
